import { render, staticRenderFns } from "./ForgetChangePassword.vue?vue&type=template&id=06621580&"
import script from "./ForgetChangePassword.vue?vue&type=script&lang=js&"
export * from "./ForgetChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgetChangePassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ForgetChangePassword.vue"
export default component.exports